(() => {
  const root = document.querySelector('[data-lic-film]');
  if (!root) return;

  const clips = [...root.querySelectorAll('[data-lic-clip]')];
  if (!clips.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    clips.forEach((clip) => {
      clip.pause();
      clip.removeAttribute('autoplay');
    });
    return;
  }

  let index = 0;

  const playAt = (next) => {
    index = next;
    clips.forEach((clip, i) => {
      const active = i === index;
      clip.classList.toggle('is-active', active);
      if (active) {
        clip.currentTime = 0;
        const start = clip.play();
        if (start && start.catch) start.catch(() => {});
      } else {
        clip.pause();
      }
    });
  };

  clips.forEach((clip, i) => {
    clip.addEventListener('ended', () => playAt((i + 1) % clips.length));
  });

  playAt(0);
})();
